import { LocalizationText } from "@/app/index";
import { Button, Col, Flex, Row, Spin, Text } from "@/base/components/index";
import variablesFigmaColors from "@/base/global/variables/figma.colors.json";
import { AlertIcon, SuccessIcon } from "@/base/static/index";
import { useContextModalHardwareInstall } from "../context/modal-hardware-install-context";
import DC701Png from "../static/dc701-3.png";

export const MModalHardwareInstallFinishActions = () => {
  const { close, currentProcess } = useContextModalHardwareInstall();

  return (
    currentProcess?.status !== "loading" && (
      <Flex gap={8} vertical align="stretch">
        <Button block size="large" type="default" onClick={close}>
          <LocalizationText value="modal.hardware.install.button.close.text" />
        </Button>
      </Flex>
    )
  );
};

export const MModalHardwareInstallFinish = () => {
  const { currentProcess } = useContextModalHardwareInstall();

  return (
    <Flex vertical align="stretch" gap={24}>
      <Row>
        <Col flex={1}>
          <Text strong>
            <LocalizationText
              value="modal.subscription.assign.finish.count.licenses.text"
              templateData={{
                count: currentProcess?.data?.BusinessUnitIds.length,
              }}
            />
          </Text>
        </Col>
        {currentProcess?.status === "loading" && (
          <Col>
            <Spin size="small" />
          </Col>
        )}

        {currentProcess?.status === "success" && (
          <Col>
            <Flex gap={4}>
              <Text>
                <LocalizationText value="modal.hardware.install.finish.install.text" />
              </Text>
              <SuccessIcon
                size={20}
                color={variablesFigmaColors.ColorFigmaFunctionalSuccess50}
              />
            </Flex>
          </Col>
        )}

        {currentProcess?.status === "error" && (
          <Col>
            <Flex gap={4}>
              <Text>{currentProcess?.error?.message}</Text>
              <AlertIcon
                size={20}
                color={variablesFigmaColors.ColorFigmaFunctionalAlert50}
              />
            </Flex>
          </Col>
        )}
      </Row>

      {currentProcess?.status === "success" && <img src={DC701Png} />}
    </Flex>
  );
};
